import type { ReactNode } from "react";
import SiteNavbar from "@/components/feature/SiteNavbar";
import SiteFooter from "@/components/feature/SiteFooter";

interface SiteLayoutProps {
  children: ReactNode;
  overlayNav?: boolean;
}

export default function SiteLayout({ children, overlayNav = false }: SiteLayoutProps) {
  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <SiteNavbar overlay={overlayNav} />
      <main className={`flex-1 ${overlayNav ? "" : "pt-16 md:pt-20"}`}>{children}</main>
      <SiteFooter />
    </div>
  );
}